import { post} from '@/https/api';

export function checkindex(aurl,data) {
    return post(aurl,data)
  }


// WEBPACK FOOTER //
// ./src/https/index.js